import React from 'react';

import { EnhancedReturnsBaseGrid } from './base-grid';
import { RequestNumberColumn, OrderNumberColumn, CreateDateColumn, CustomerNameColumn, CustomerEmailColumn, AmountColumn } from './columns';

const columns = [RequestNumberColumn, OrderNumberColumn, CreateDateColumn, CustomerNameColumn, CustomerEmailColumn, AmountColumn];

const viewSpecificFilters = [];

// TODO: https://auctane.atlassian.net/browse/SPD-20142 Column Configs per view/user?
export const EnhancedReturnsPendingApproval = () => {
  return <EnhancedReturnsBaseGrid columns={columns} viewSpecificFilters={viewSpecificFilters} />;
};
